const AllAggregators = () => {
	return <div>AllAggregators</div>;
};

export default AllAggregators;
